import { render, staticRenderFns } from "./ChildCourseFormDialog.vue?vue&type=template&id=4987f8de"
import script from "./ChildCourseFormDialog.vue?vue&type=script&lang=js"
export * from "./ChildCourseFormDialog.vue?vue&type=script&lang=js"
import style0 from "./ChildCourseFormDialog.vue?vue&type=style&index=0&id=4987f8de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports